module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "countdown"
  }, [(_vm.minutes && _vm.seconds) ? [_c('h6', {
    staticClass: "countdown__title"
  }, [_vm._v("Time Remaining")]), _vm._v(" "), (!_vm.loading) ? _c('h1', {
    staticClass: "countdown__timer"
  }, [_vm._v(_vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds))]) : _c('h1', {
    staticClass: "countdown__timer"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "30",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showWarning),
      callback: function($$v) {
        _vm.showWarning = $$v
      },
      expression: "showWarning"
    }
  }, [_c('h3', [_vm._v("Your booking session will expire in\n                "), (_vm.minutes != '00') ? [_vm._v(_vm._s(_vm.minutes) + " minutes!")] : [_vm._v(_vm._s(_vm.seconds) + " seconds!")]], 2), _vm._v(" "), _c('p', [_vm._v("\n                Please click continue to carry on.\n            ")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        _vm.continueOrder()
      }
    }
  }, [_vm._v("Continue With Booking")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelOrder()
      }
    }
  }, [_vm._v("Cancel")])], 1)] : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showTimeout),
      callback: function($$v) {
        _vm.showTimeout = $$v
      },
      expression: "showTimeout"
    }
  }, [_c('h3', [_vm._v("Looks like your booking session has expired.")]), _vm._v(" "), _c('p', [_vm._v(" Don't worry, it's easy to start again.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        _vm.restartOrder()
      }
    }
  }, [_vm._v("Start again")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55233f2a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/countdown/countdown.vue
// module id = 739
// module chunks = 0